import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
  type RouterScrollBehavior,
} from "vue-router";

import DeliveryRequestRegisterStart from "@/views/DeliveryRequestRegisterStart/index.vue";
import DeliveryRequestRegisterInput from "@/views/DeliveryRequestRegisterInput/index.vue";
import DeliveryRequestList from "@/views/DeliveryRequestList/index.vue";

import DeliveryMoveList from "@/views/DeliveryMoveList/index.vue";
import DeliveryMoveRegister from "@/views/DeliveryMoveRegister/index.vue";

import FixturesRegister from "@/views/FixturesRegister/index.vue";

import MemberRegister from "@/views/MemberRegister/index.vue";
import MemberList from "@/views/MemberList/index.vue";
import TmpMemberList from "@/views/TmpMemberList/index.vue";
import TmpMemberQrCode from "@/views/TmpMemberQrCode/index.vue";

import ShopRegister from "@/views/admin/ShopRegister/index.vue";
import ShopList from "@/views/admin/ShopList/index.vue";

import OperatorRegister from "@/views/admin/OperatorRegister/index.vue";
import OperatorList from "@/views/admin/OperatorList/index.vue";
import AreaList from "@/views/admin/AreaList/index.vue";

import DeliverySetting from "@/views/admin/DeliverySetting/index.vue";
import DeliveryCapSetting from "@/views/admin/DeliveryCapSetting/index.vue";
import ScheduledDeliveryList from "@/views/admin/ScheduledDeliveryList/index.vue";
import ScheduledDeliveryRegister from "@/views/admin/ScheduledDeliveryRegister/index.vue";
import ChainRegister from "@/views/admin/ChainRegister/index.vue";
import SalesSummaryList from "@/views/admin/SalesSummaryList/index.vue";

import RegularDeliveryList from "@/views/RegularDeliveryList/index.vue";
import RegularDeliveryRegister from "@/views/RegularDeliveryRegister/index.vue";

import PasswordChange from "@/views/PasswordChange/index.vue";

import { routerPath } from "@/common/router";

import store from "@/store";

const routes: RouteRecordRaw[] = [
  {
    path: routerPath.login,
    name: "Login",
    component: DeliveryRequestRegisterStart,
  },
  {
    // 配送依頼登録-開始
    path: routerPath.deliveryRequestRegisterStart,
    name: "DeliveryRequestRegisterStart",
    component: DeliveryRequestRegisterStart,
  },
  {
    // 配送依頼登録-入力
    path: routerPath.deliveryRequestRegisterInput,
    name: "DeliveryRequestRegisterInput",
    component: DeliveryRequestRegisterInput,
  },
  {
    // 配送依頼一覧
    path: routerPath.deliveryRequestList,
    name: "DeliveryRequestList",
    component: DeliveryRequestList,
  },
  {
    // 在庫移動登録-入力
    path: routerPath.deliveryMoveRegister,
    name: "DeliveryMoveRegister",
    component: DeliveryMoveRegister,
  },
  {
    // 在庫移動一覧
    path: routerPath.deliveryMoveList,
    name: "DeliveryMoveList",
    component: DeliveryMoveList,
  },
  {
    // 資材発注登録
    path: routerPath.fixturesRegister,
    name: "FixturesRegister",
    component: FixturesRegister,
  },
  {
    // 定期配送・一覧
    path: routerPath.regularDeliveryList,
    name: "RegularDeliveryList",
    component: RegularDeliveryList,
  },
  {
    // 定期配送
    path: routerPath.regularDeliveryRegister,
    name: "RegularDeliveryRegister",
    component: RegularDeliveryRegister,
  },
  {
    // 会員登録
    path: routerPath.memberRegister,
    name: "MemberRegister",
    component: MemberRegister,
  },
  {
    // 会員一覧
    path: routerPath.memberList,
    name: "MemberList",
    component: MemberList,
  },
  {
    // 仮会員一覧
    path: routerPath.tmpMemberList,
    name: "TmpMemberList",
    component: TmpMemberList,
  },
  {
    // 仮会員登録用QRコード
    path: routerPath.tmpMemberQrCode,
    name: "TmpMemberQrCode",
    component: TmpMemberQrCode,
  },
  {
    // 店舗登録
    path: routerPath.shopRegister,
    name: "ShopRegister",
    component: ShopRegister,
  },
  {
    // 店舗一覧
    path: routerPath.shopList,
    name: "ShopList",
    component: ShopList,
    props: true,
  },
  {
    // チェーン登録
    path: routerPath.chainRegister,
    name: "ChainRegister",
    component: ChainRegister,
  },
  {
    // オペレータ登録
    path: routerPath.operatorRegister,
    name: "OperatorRegister",
    component: OperatorRegister,
  },
  {
    // オペレータ一覧
    path: routerPath.operatorList,
    name: "OperatorList",
    component: OperatorList,
    props: true,
  },
  {
    // エリア一覧
    path: routerPath.areaList,
    name: "AreaList",
    component: AreaList,
  },
  {
    // 配達設定
    path: routerPath.deliverySetting,
    name: "DeliverySetting",
    component: DeliverySetting,
  },
  {
    // 臨時キャップ変更
    path: routerPath.deliveryCapSetting,
    name: "DeliveryCapSetting",
    component: DeliveryCapSetting,
  },
  {
    // 店舗間定期配達・一覧
    path: routerPath.scheduledDeliveryList,
    name: "ScheduledDeliveryList",
    component: ScheduledDeliveryList,
  },
  {
    // 店舗間定期配達
    path: routerPath.scheduledDeliveryRegister,
    name: "ScheduledDeliveryRegister",
    component: ScheduledDeliveryRegister,
  },
  {
    // 売上集計
    path: routerPath.salesSummaryList,
    name: "SalesSummaryList",
    component: SalesSummaryList,
  },
  {
    // パスワード変更
    path: routerPath.passwordChange,
    name: "PasswordChange",
    component: PasswordChange,
  },
];

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  // savedPosition があれば復元
  if (savedPosition) {
    return savedPosition;
  }
  // それ以外はトップにスクロール
  return { left: 0, top: 0 };
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior,
});

// ✅ ルート遷移後に毎回 listEditOff を呼ぶ
router.afterEach((to, from, failure) => {
  if (failure) return; // 失敗した遷移は無視

  // ログイン画面に遷移した時は不要なら、こういう条件も付けられます
  // if (to.path === routerPath.login) return;

  store.commit("listEditOff");
});

export default router;
